import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4bfda280"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "h-full flex flex-row" };
const _hoisted_2 = { class: "w-16 h-full border-r border-gray-200 space-y-2 overflow-y-scroll" };
import { Tools } from '@/types/tools';
import { Brush01Icon, Contrast01Icon, Crop02Icon, Settings04Icon, Stars03Icon, StickerCircleIcon, TransformIcon, Type02Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UITooltip } from '@gohighlevel/ghl-ui';
import { ref } from 'vue';
import Adjustments from './tools/AdjustmentsTool';
// import AI from './tools/AiTool'
import Crop from './tools/CropTool';
import Filters from './tools/FiltersTool';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImageOptions',
    props: {
        stage: {
            type: Object,
            require: true,
        },
        group: {
            type: Object,
            require: true,
        },
        baseImage: {
            type: Object,
            require: true,
        },
        reset: {
            type: Boolean,
            require: true,
        },
        loading: {
            type: Boolean,
            require: true,
        },
        sectionReset: {
            type: Boolean,
            require: true,
        },
        disableAction: {
            type: Boolean,
            require: true,
        },
    },
    emits: ['applied', 'reset', 'change-active-tool', 'update'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const selectedOption = ref(Tools.CROP);
        function changeTools(val) {
            if (props.loading || props.disableAction)
                return;
            selectedOption.value = val;
            emits('change-active-tool', val);
        }
        function applied(type) {
            emits('applied', type);
        }
        function changed(type) {
            emits('update', type);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["h-12 py-2 px-2 flex items-center justify-center cursor-pointer", { 'bg-primary-600': selectedOption.value == _unref(Tools).CROP }]),
                        onClick: _cache[0] || (_cache[0] = ($event) => (changeTools(_unref(Tools).CROP)))
                    }, [
                        _createVNode(_unref(Crop02Icon), {
                            class: _normalizeClass(["w-5 h-5", selectedOption.value == _unref(Tools).CROP ? 'text-white' : 'text-gray-700'])
                        }, null, 8, ["class"])
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["h-12 py-2 px-2 flex items-center justify-center cursor-pointer", { 'bg-primary-600': selectedOption.value == _unref(Tools).FILTERS }]),
                        onClick: _cache[1] || (_cache[1] = ($event) => (changeTools(_unref(Tools).FILTERS)))
                    }, [
                        _createVNode(_unref(Stars03Icon), {
                            class: _normalizeClass(["w-5 h-5",
                                selectedOption.value == _unref(Tools).FILTERS ? 'text-white' : 'text-gray-700'
                            ])
                        }, null, 8, ["class"])
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["h-12 py-2 px-2 flex items-center justify-center cursor-pointer", { 'bg-primary-600': selectedOption.value == _unref(Tools).ADJUSTMENTS }]),
                        onClick: _cache[2] || (_cache[2] = ($event) => (changeTools(_unref(Tools).ADJUSTMENTS)))
                    }, [
                        _createVNode(_unref(Settings04Icon), {
                            class: _normalizeClass(["w-5 h-5",
                                selectedOption.value == _unref(Tools).ADJUSTMENTS ? 'text-white' : 'text-gray-700'
                            ])
                        }, null, 8, ["class"])
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["h-12 py-2 px-2 flex items-center justify-center cursor-pointer", { 'bg-primary-600': selectedOption.value == _unref(Tools).FRAMES }])
                    }, [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(TransformIcon), {
                                    class: _normalizeClass(["w-5 h-5 text-gray-400", { 'text-white': selectedOption.value == _unref(Tools).FRAMES }])
                                }, null, 8, ["class"])
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.comingSoon')), 1)
                            ]),
                            _: 1
                        })
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["h-12 py-2 px-2 flex items-center justify-center cursor-pointer", { 'bg-primary-600': selectedOption.value == _unref(Tools).OVERLAYS }])
                    }, [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(Contrast01Icon), {
                                    class: _normalizeClass(["w-5 h-5 text-gray-400", { 'text-white': selectedOption.value == _unref(Tools).OVERLAYS }])
                                }, null, 8, ["class"])
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.comingSoon')), 1)
                            ]),
                            _: 1
                        })
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["h-12 py-2 px-2 flex items-center justify-center cursor-pointer", { 'bg-primary-600': selectedOption.value == _unref(Tools).TEXT }])
                    }, [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(Type02Icon), {
                                    class: _normalizeClass(["w-5 h-5 text-gray-400", { 'text-white': selectedOption.value == _unref(Tools).TEXT }])
                                }, null, 8, ["class"])
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.comingSoon')), 1)
                            ]),
                            _: 1
                        })
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["h-12 py-2 px-2 flex items-center justify-center cursor-pointer", { 'bg-primary-600': selectedOption.value == _unref(Tools).STICKERS }])
                    }, [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(StickerCircleIcon), {
                                    class: _normalizeClass(["w-5 h-5 text-gray-400", { 'text-white': selectedOption.value == _unref(Tools).STICKERS }])
                                }, null, 8, ["class"])
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.comingSoon')), 1)
                            ]),
                            _: 1
                        })
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["h-12 py-2 px-2 flex items-center justify-center cursor-pointer", { 'bg-primary-600': selectedOption.value == _unref(Tools).BRUSH }])
                    }, [
                        _createVNode(_unref(UITooltip), null, {
                            trigger: _withCtx(() => [
                                _createVNode(_unref(Brush01Icon), {
                                    class: _normalizeClass(["w-5 h-5 text-gray-400", { 'text-white': selectedOption.value == _unref(Tools).BRUSH }])
                                }, null, 8, ["class"])
                            ]),
                            default: _withCtx(() => [
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.comingSoon')), 1)
                            ]),
                            _: 1
                        })
                    ], 2)
                ]),
                _createVNode(_unref(Crop), {
                    class: _normalizeClass(["h-full flex flex-col border-r border-gray-200 hl_image-editor-drawer",
                        !selectedOption.value || selectedOption.value == _unref(Tools).CROP ? 'is-open' : 'hidden'
                    ]),
                    style: _normalizeStyle([{ "width": "280px" }, selectedOption.value != _unref(Tools).CROP ? 'display: none;' : '']),
                    stage: __props.stage,
                    group: __props.group,
                    "base-image": __props.baseImage,
                    "selected-option": selectedOption.value,
                    reset: __props.reset,
                    loading: __props.loading,
                    onApplied: _cache[3] || (_cache[3] = ($event) => (applied(_unref(Tools).CROP)))
                }, null, 8, ["class", "style", "stage", "group", "base-image", "selected-option", "reset", "loading"]),
                (__props.baseImage)
                    ? (_openBlock(), _createBlock(_unref(Adjustments), {
                        key: 0,
                        class: _normalizeClass(["h-full flex flex-col border-r border-gray-200 hl_image-editor-drawer", selectedOption.value == _unref(Tools).ADJUSTMENTS ? 'is-open' : 'hidden']),
                        style: _normalizeStyle([{ "width": "280px" }, selectedOption.value != _unref(Tools).ADJUSTMENTS ? 'display: none;' : '']),
                        "base-image": __props.baseImage,
                        reset: __props.reset,
                        "section-reset": __props.sectionReset,
                        "selected-option": selectedOption.value,
                        onChange: _cache[4] || (_cache[4] = ($event) => (changed(_unref(Tools).ADJUSTMENTS)))
                    }, null, 8, ["class", "style", "base-image", "reset", "section-reset", "selected-option"]))
                    : _createCommentVNode("", true),
                (__props.baseImage)
                    ? (_openBlock(), _createBlock(_unref(Filters), {
                        key: 1,
                        class: _normalizeClass(["h-full flex flex-col border-r border-gray-200 hl_image-editor-drawer", selectedOption.value == _unref(Tools).FILTERS ? 'is-open' : 'hidden']),
                        style: _normalizeStyle([{ "width": "280px" }, selectedOption.value != _unref(Tools).FILTERS ? 'display: none;' : '']),
                        "base-image": __props.baseImage,
                        reset: __props.reset,
                        "section-reset": __props.sectionReset,
                        "selected-option": selectedOption.value,
                        onChange: _cache[5] || (_cache[5] = ($event) => (changed(_unref(Tools).FILTERS)))
                    }, null, 8, ["class", "style", "base-image", "reset", "section-reset", "selected-option"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
